import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AbacusComp  from "./Component/AbacusComp"

const Abacus =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AbacusComp />
        </div>
        <Footer />
        </>
    )
}

export default Abacus